import { hashFromString } from '@/models/common';
import { fetchEnum } from '@/services/okFormResource';

const defaultGetKey = item => item.id;
const defaultGetValue = item => item.description;
const defaultGetCustomData = () => null;

const enumFactory = (endpoint, methods) => async params => {
  const enumDefinition = await fetchEnum(endpoint, params);

  const { getKey, getLabel, getCustomData } = {
    getKey: defaultGetKey,
    getLabel: defaultGetValue,
    getCustomData: defaultGetCustomData,
    ...methods,
  };

  return {
    data: enumDefinition.map(item => {
      return {
        key: getKey(item),
        label: getLabel(item),
        ...getCustomData(item),
      };
    }),
  };
};

export const organizationTypeEnum = enumFactory('organization-types');

export const countryEnum = enumFactory('country', {
  getLabel: item => `${item.iso} - ${item.name}`,
  getCustomData: ({ isInEU }) => ({ isInEU }),
});
export const titleBeforeEnum = enumFactory('title-before');
export const titleAfterEnum = enumFactory('title-after');
export const jobInformationSourceEnum = enumFactory('job-information-source');
export const howAppliedForJobEnum = enumFactory('how-applied-for-job');
export const lastJobEnum = enumFactory('last-job');
export const pensionEnum = enumFactory('pension');
export const healthInsuranceEnum = enumFactory('health-insurence');
export const sexEnum = enumFactory('sex');
export const educationalAttainmentEnum = enumFactory('educational-attainment', {
  getLabel: item => `${item.code} - ${item.description}`,
  getCustomData: ({ code }) => ({ code }),
});
export const schoolEnum = enumFactory('school', {
  getLabel: item => item.shortName,
});
export const oborSpecializacnihoVzdelaniFarmaceutuEnum = enumFactory(
  'obor-specializacniho-vzdelani-farmaceutu'
);
export const oborSpecializacnihoVzdelaniFarmaceutickychAsistentuEnum = enumFactory(
  'obor-specializacniho-vzdelani-farmaceutickych-asistentu'
);
export const organizationsEnum = enumFactory('organizations', {
  getCustomData: item => ({
    organizationalUnits: {
      data: item.organizationalUnits.map(unit => ({
        key: defaultGetKey(unit),
        label: `${unit.okCode} - ${unit.description}`,
      })),
    },
  }),
});
export const positionTypeEnum = enumFactory('position-type');
export const workTimeEnum = enumFactory('work-time');
export const smennostEnum = enumFactory('smennost');
export const bankEnum = enumFactory('bank', {
  getKey: item => item.code,
  getLabel: item => `${item.code} - ${item.name}`,
});

const mapDocuments = document => {
  const { defaultDocumentTypeId, documentTypes } = document;
  return {
    defaultDocumentTypeId,
    documentsDef: documentTypes.map(({ id, description }) => ({
      key: id,
      label: description,
    })),
    _hash: hashFromString(JSON.stringify(document)),
  };
};

export const documentsDefinition = async () => {
  const documentsByNationalityAndGroup = await fetchEnum('document-by-nationality-and-group');

  const documentsDefinition = {
    cz: documentsByNationalityAndGroup.czechNationalityDocumentTypes.map(mapDocuments),
    eu: documentsByNationalityAndGroup.euNationalityDocumentTypes.map(mapDocuments),
    other: documentsByNationalityAndGroup.otherNationalityDocumentTypes.map(mapDocuments),
  };

  return documentsDefinition;
};
